import React, {useEffect, useState} from 'react'
import {WordCloud} from '@ant-design/plots';
import {NewsApi} from "../../services/NewsApi";
import {Spin} from "antd";

const NewsDashboardKeywordCloud = () => {

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])

    useEffect(() => {
        NewsApi.keywordCloud(30)
            .onSuccess(data => {
                const d = data.map(d => {
                    return {
                        ...d,
                        value: Number(d.value)
                    }
                })
                setData(d)
            })
            .onComplete(() => setLoading(false))
    }, [])

    const config = {
        data: data,
        wordField: 'x',
        weightField: 'value',
        color: '#122c6a',
        wordStyle: {
            fontFamily: 'Verdana',
            fontSize: [24, 80],
        },
        // 设置交互类型
        interactions: [
            {
                type: 'element-active',
            },
        ],
        state: {
            active: {
                // 这里可以设置 active 时的样式
                style: {
                    lineWidth: 3,
                },
            },
        },
    }

    return (
        <Spin spinning={loading}>
            <WordCloud {...config} />
        </Spin>
    )
}

export default NewsDashboardKeywordCloud